// The opening, by family or a deeper name, matched as a prefix.
import { text, type FilterCriterion } from '../criterion.ts';
import { foldOpening, openingFamily, openingNameOf, openingVariation } from '../openings.ts';
import { byFrequency } from '../suggest.ts';

export const opening: FilterCriterion<'opening'> = {
  key: 'opening',
  query: 'opening',
  ...text,
  matches: (game, v) => {
    const name = game.pgn ? openingNameOf(game.pgn) : undefined;
    const wanted = foldOpening(v);
    const starts = (candidate: string | undefined) => !!candidate && foldOpening(candidate).startsWith(wanted);
    return !!name && (starts(openingFamily(name)) || starts(openingVariation(name)) || starts(name));
  },
  // A link from the openings screen carries one exact variation: the field
  // shows it, and typing replaces it with a plain opening match.
  control: {
    kind: 'text',
    order: 70,
    label: 'Opening',
    placeholder: 'e.g. Sicilian Defense',
    read: (f) => f.variation ?? f.opening,
    write: (f, v) => ({ ...f, opening: v, variation: undefined }),
    // The families played, most played first, then their variations.
    suggest: (games) => {
      const names = games.map((g) => (g.pgn ? openingNameOf(g.pgn) : undefined)).filter((n): n is string => !!n);
      return [...new Set([...byFrequency(names.map(openingFamily)), ...byFrequency(names.map(openingVariation))])];
    },
  },
};
